module.exports = __webpack_public_path__ + "static/img/duom022.ae03087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom022.png
// module id = 989
// module chunks = 0